import Grid from '@mui/material/Grid';
import React, {useState} from 'react';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import {useTranslation} from 'react-i18next';
import AgyleDictionaryField from '../../../components/ui/selector/agyleDictionaryField';
import useDict from '../../../hooks/useDict';
import {PATIENT_CONTEXT_TYPE} from '../../../util/patientContextUtil';
import MiniFormDialog from '../../../components/modal/miniFormDialog';
import Notes from '../../../util/notes';

const EcsEmailModal = ({onClose, open, onChange, patient, patientType, disableSave, _formOptions}) => {
    const {t} = useTranslation();

    const [formName] = useState(patientType === PATIENT_CONTEXT_TYPE.EDAU ? 'edauEcs' : 'ecs');

    const [casMailsOptions, isCasMailsLoading] = useDict('CasMails');
    const [mail, setMail] = useState(patient?.studies?.[formName + 'Email']?.mail || null);
    const [text, setText] = useState(patient?.studies?.[formName + 'Email']?.text || '');

    const getType = () => patientType !== PATIENT_CONTEXT_TYPE.EDAU ? 'CAS CARD' : 'EDAU DOCUMENTATION DOR';

    const createECS = () => {
        if (onChange) {
            onChange([{
                name: `studies.${formName}Email`,
                value: {
                    mail,
                    text,
                },
                noteToAdd: Notes.getECSEmailNote(getType(), mail, text),
            }]);
        }
        onClose();
    };

    const handleChange = (_e, val) => {
        setMail(val);
    };

    const handleChangeText = (event) => {
        setText(event.target.value);
    };

    const renderEmailsList = (props, option) => {
        return (
            <li {...props}>
                {option?.name} ({option?.emails?.toString()})
            </li>
        );
    };

    return (
        <>
            <MiniFormDialog
                title={`SEND ${getType()}`}
                open={open}
                onClose={onClose}
                onSave={createECS}
                disableSubmit={!mail || !text || disableSave}
                formOptions={_formOptions}
            >
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                        <AgyleDictionaryField
                            label={t('Email to')}
                            renderLocalOption={renderEmailsList}
                            options={casMailsOptions}
                            onChange={handleChange}
                            value={mail}
                            size="large"
                            loading={isCasMailsLoading}
                            getOptionLabel={(mail => mail.name + ' (' + mail.emails + ')')}
                            noBorder={false}
                            withNewBackground
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <AgyleTextField
                            name="text"
                            label={t('Text')}
                            multiline
                            maxRows={5}
                            onChange={handleChangeText}
                            value={text}
                            fullWidth
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>
                </Grid>
            </MiniFormDialog>
        </>
    );
};

export default EcsEmailModal;